var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":"uploadFile"},on:{"click":_vm.clickFile}},[_c('van-icon',{attrs:{"name":"notes-o","size":"20","color":"rgba(0, 0, 0, 0.65)"}}),_vm._v(" "),_c('input',{ref:"imgDom",staticClass:"hide",attrs:{"type":"file"},on:{"change":_vm.fileChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36a00601","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upLoadFile/index.vue
// module id = null
// module chunks = 